"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faAngleDown_1 = require("@fortawesome/pro-regular-svg-icons/faAngleDown");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var StyledAccordionSummary = (0, styles_1.styled)(material_1.AccordionSummary, {
    shouldForwardProp: function (prop) { return prop !== 'edgePosition'; },
})(function (_a) {
    var edgePosition = _a.edgePosition, theme = _a.theme;
    return ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(0.5, 2),
        position: 'relative',
        minHeight: 64,
        '&:hover': {
            background: theme.palette.secondary.light,
        },
        '& .MuiAccordionSummary-content': {
            '&.Mui-expanded': {
                margin: 0,
            },
        },
        '.MuiAccordionSummary-expandIconWrapper': __assign({}, (edgePosition === 'start' && {
            '&.Mui-expanded': {
                transform: 'rotate(360deg)',
            },
            order: -1,
            transform: 'rotate(270deg)',
            marginLeft: theme.spacing(1.5),
        })),
    });
});
var AccordionSummary = (0, DefaultPropsHoC_1.default)(StyledAccordionSummary, {
    expandIcon: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faAngleDown_1.faAngleDown, color: "#7f7f7f", size: "lg" }),
    edgePosition: 'end',
});
exports.default = AccordionSummary;
